import CreateClientForm from "@/components/Forms/CreateClientForm";

const DashboardAllEndClientsUpdate = () => {
  return <CreateClientForm isEndClient={true}/>;
};

export default DashboardAllEndClientsUpdate;
